import { observer } from "mobx-react";
import { useStores } from "../../../../..";
import {
  BottomDefaultButton,
  DeleteDefaultButton,
  TopDefaultButton,
} from "../../../../../Components/IconButtons";
import { LearningPathModuleResponseApi } from "../../../../../DTO/ServerResponseType/LearningPath/LearningPathModule";
import { LearningPathStore } from "../../../../../Stores/LearningPathStores/LearningPathStore";
import TreeNodeApi from "./TreeNodeApi";
import { TreeNode } from "./TreeNode";

const getModuleNode = (
  learningPathStore: LearningPathStore,
  learningPathModule: LearningPathModuleResponseApi
): TreeNodeApi => {
  return {
    value: learningPathModule.learningPathModuleId,
    label: (
      <ModuleNode
        learningPathStore={learningPathStore}
        learningPathModule={learningPathModule}
      />
    ),
  };
};

const ModuleNode: React.FC<{
  learningPathStore: LearningPathStore;
  learningPathModule: LearningPathModuleResponseApi;
}> = observer(({ learningPathStore, learningPathModule }) => {
  let learningPathWindowStore = useStores().learningPathWindowStore;

  return (
    <TreeNode
      label={
        <>
          {learningPathModule.learningPathModuleOrder}.&emsp;
          {learningPathModule.module.moduleName}
        </>
      }
      buttons={
        <>
          {learningPathStore.doSave && (
            <>
              {learningPathModule.learningPathModuleOrder !== 1 && (
                <TopDefaultButton
                  withShadow={false}
                  onClick={() => {
                    learningPathStore.onChangeNeighboringModuleOrder(
                      learningPathModule,
                      learningPathModule.learningPathModuleOrder - 1
                    );
                  }}
                />
              )}
              {learningPathModule.learningPathModuleOrder !==
                learningPathStore.learningPath.learningPathModules.length && (
                <BottomDefaultButton
                  withShadow={false}
                  onClick={() => {
                    learningPathStore.onChangeNeighboringModuleOrder(
                      learningPathModule,
                      learningPathModule.learningPathModuleOrder + 1
                    );
                  }}
                />
              )}
              <DeleteDefaultButton
                withShadow={false}
                onClick={() => {
                  learningPathWindowStore.onDeleteModalToDeleteLearningPathModuleOpen(
                    learningPathStore.learningPath,
                    learningPathModule.module
                  );
                }}
              />
            </>
          )}
        </>
      }
    />
  );
});

export default getModuleNode;
